export class VatCalculatingError extends Error {
    public readonly name: string;
    public readonly stack: string;

    constructor(message: string, stack: string = '') {
        super(message);
        this.name = 'VatServiceFailed';
        this.stack = stack;
        Object.setPrototypeOf(this, VatCalculatingError.prototype);
    }
}
